module.exports = __webpack_public_path__ + "static/media/tu-dublin.983a8972.png";